module.exports = __webpack_public_path__ + "static/img/7.4cb0ccb.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/loading/img/7.png
// module id = 4ET3
// module chunks = 0